import { useQuery } from '@tanstack/react-query';

import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { coverageQueries } from '@/lib/queries/coverage';
import type { Project } from '@/lib/queries/project';
import { resourceQueries } from '@/lib/queries/resource';

import { ResourceDetails } from './ResourceDetails';

export const Coverage = ({
  hashedID,
  mainProject,
  from,
  to,
}: {
  hashedID: string;
  mainProject: Project;
  from?: string;
  to?: string;
}): JSX.Element => {
  const {
    data: coverageData,
    isPending: isCoveragePending,
    isError: isCoverageError,
    refetch,
  } = useQuery(coverageQueries.list(mainProject.id));

  const {
    data: impactsData,
    isPending: isImpactsPending,
    isError: isImpactsError,
  } = useQuery(resourceQueries.impacts(mainProject.id, hashedID, from, to));

  if (isCoveragePending || isImpactsPending) {
    return (
      <div className="space-y-4 mb-16">
        <Skeleton className="h-8 w-60 bg-background mb-8" />
        <Skeleton className="h-6 w-full bg-background" />
        <Skeleton className="h-6 w-full bg-background" />
        <Skeleton className="h-6 w-full bg-background" />
      </div>
    );
  }

  if (isCoverageError || isImpactsError) {
    return (
      <div className="mt-12">
        <p>Failed to get impacts data for this resource...</p>
        <Button onClick={() => refetch()} variant="main">
          Retry
        </Button>
      </div>
    );
  }

  return (
    <ResourceDetails
      hashedID={hashedID}
      resources={coverageData}
      historyImpacts={impactsData.data}
      from={from}
      to={to}
    />
  );
};
